import React from "react";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { GiftCard } from "@/components/site/GiftCard";
import { Reviews } from "@/components/site/Reviews";
import { Contact } from "@/components/site/Contact";
import { useSeo } from "@/hooks/useSeo";

export default function Home() {
  useSeo({
    title: "Ninaa Beauty — Institut de beauté & bien-être à Toulouse",
    description:
      "Institut de beauté à Toulouse centre : massages bien-être, soins du visage, beauté du regard et épilation. Esthéticienne à Toulouse, près de Jean-Jaurès et Matabiau. Réservez votre moment de détente.",
    path: "/",
  });
  return (
    <div className="App" data-testid="app-root">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <GiftCard />
        <Reviews />
      </main>
      <Contact />
    </div>
  );
}
